import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00C853', // Verde acento
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#222222', // Negro
      contrastText: '#ffffff',
    },
    background: {
      default: '#f7fafc', // Gris claro
      paper: '#ffffff',   // Blanco para cartas
    },
    text: {
      primary: '#222222', // Negro
      secondary: '#333333', // Gris oscuro
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
    h2: {
      fontWeight: 700,
      color: '#222222',
    },
    h5: {
      fontWeight: 600,
      color: '#222222',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: '#222222',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export default theme;

